import React, { useState } from "react";
import axios from "axios";

const url = process.env.REACT_APP_SERVER_URL || "https://food.stall-centralsoft.com/api";

function AdminLogin() {
  const [adminID, setAdminID] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${url}/login`, {
        adminID,
        password,
      });
      alert(res.data.username);
      if (res.data.success) {
        setMessage("✅ Login success!");
        localStorage.setItem("username", res.data.username);
        localStorage.setItem("adminID", res.data.stallID);      
      } else {
        setMessage("❌ Invalid login, try again");
      }
    } catch (err) {
      console.error(err);
      setMessage("⚠️ Server error");
    }
  };

  return (
    <div style={{ maxWidth: "350px", margin: "20px auto", textAlign: "left" }}>
      <h4>Admin Login</h4>
      <form onSubmit={handleLogin}>
        <div className="mb-3">
          <label className="form-label">Stall ID</label>
          <input
            type="text"
            className="form-control"
            value={adminID}
            onChange={(e) => setAdminID(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Password</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="btn btn-primary w-100">
          Login
        </button>
      </form>
      {message && <p style={{ marginTop: "10px" }}>{message}</p>}
    </div>
  );
}

export default AdminLogin;
